import { FC } from "react";

import FullLogoDarkMode from "@/assets/images/full_logo_dark_mode.svg";
import FullLogoLightMode from "@/assets/images/full_logo_light_mode.svg";
import { useAppTheme } from "@/hooks/useAppTheme";

type FullLogoPropsType = {
  className?: string;
  color?: string;
};

export const FullLogo: FC<FullLogoPropsType> = ({ className, color }) => {
  const { isDarkMode } = useAppTheme();

  const Logo = isDarkMode ? FullLogoDarkMode : FullLogoLightMode;

  return <Logo className={className} color={color} />;
};
